import React from "react";
import { Container, withModal, withStyles } from "components/common";
import { convertToShortDate } from "utils/convert-date";
import formatCurrency from "utils/formatCurrency";
import { compose } from "redux";

const PaymentStatement = ({
  user: {
    payment_due_date,
    payment_due_balance,
    payment_methods = [],
    default_payment_method_id,
    autopay_frequency,
  } = {},
  hideAutopayDescription = false,
  modalContext: { openModal },
}) => {
  const renderDiv = (title, value) => (
    <div className="mt-2 flex">
      <p className="font-semibold mr-1">{`${title}:`}</p>
      <p>{value}</p>
    </div>
  );

  const nextTriggerDate = payment_due_date
    ? convertToShortDate(payment_due_date)
    : "No due date";

  const amount = Math.max(-payment_due_balance, 0)
    ? `${formatCurrency(Math.max(-payment_due_balance, 0))}`
    : "No payment due";

  const defaultMethodObj =
    payment_methods.find((m) => m.id === default_payment_method_id) || {};

  const defaultMethod = `${defaultMethodObj.institution || "unknown"} (**${
    defaultMethodObj.account_number_last_four || "unknown"
  })`;

  return (
    <div className="w-full h-full">
      <Container paddingVertical={16} className="w-full flex-1 h-full">
        <div className="flex flex-col text-center md:text-left">
          <div className="flex">
            <p className="font-bold mr-1 text-lg">Autopay:</p>
            <p className="font-semibold text-green-primary text-lg capitalize">
              {
                // eslint-disable-next-line
                autopay_frequency == "biweekly"
                  ? "bi-weekly"
                  : autopay_frequency
              }
            </p>
          </div>
          {renderDiv("Next trigger date", nextTriggerDate)}
          {renderDiv("Amount", amount)}
          {renderDiv("Default method", defaultMethod)}
        </div>

        {!hideAutopayDescription && (
          <span
            className="md:hidden mt-2 text-green-primary underline cursor-pointer"
            onClick={(e) => {
              openModal(e, "PaymentAutopayInfoModal");
            }}
          >
            How much am I paying?
          </span>
        )}
      </Container>
    </div>
  );
};

export default compose(withStyles, withModal)(PaymentStatement);
